import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss']
})
export class LoadingDialogComponent implements OnInit, OnDestroy {
  label: string;
  loaderType: string;

  constructor(public dialogRef: MatDialogRef<LoadingDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    // const url = ANONYMIZATION_STATUS_WEBSOCKET + JSON.parse(localStorage.getItem('currentUser')).token;
    //
    // this.anonymizationStatusWebSocket = webSocket(url);
    // this.anonymizationStatusWebSocket.pipe(retry()).subscribe(
    //   msg => {
    //     if (msg.type === 'preparing_download') {
    //       if (msg.token === this.data.queueId) {
    //         this.data.status = msg.progress;
    //       }
    //     }
    //   },
    //   error => {},
    // );
    //

  }

  ngOnDestroy() {
    // this.anonymizationStatusWebSocket.unsubscribe();
  }

}
